import CreateBlogContainer from "../containers/CreateBlogContainer";

const CreateBlogPage = () => {
  return (
    <CreateBlogContainer />
  );
};

export default CreateBlogPage;
